import { gapi } from "gapi-script";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "ID_JUYT";
// const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET;
const API_KEY = process.env.REACT_APP_API_KEY || "";

// const DISCOVERY_DOCS = [
//   "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
// ];

// const SCOPES = "https://www.googleapis.com/auth/drive.file";

// URL për `discoveryDocs` dhe `scopes`

const DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
];
const SCOPES = "https://www.googleapis.com/auth/drive.file";

export const initGoogleDriveClient = () => {
  gapi.load("client:auth2", async () => {
    try {
      await gapi.client.init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      });

      if (!gapi.auth2.getAuthInstance()) {
        console.error("gapi.auth2 is not initialized");
        return;
      }
    } catch (error) {
      console.error("Error initializing GAPI client:", error);
    }
  });
};

export const signInToGoogle = async () => {
  try {
    const authInstance = gapi.auth2.getAuthInstance();

    // Check if authInstance exists
    if (!authInstance) {
      console.error("Google Auth instance not initialized.");
      return null;
    }

    // Call the sign-in method
    const user = await authInstance.signIn();
    const authResponse = user.getAuthResponse();

    // Log the user and authResponse

    return authResponse.access_token; // Return the access token to be sent to the backend
  } catch (error) {
    console.error("Error during sign-in:", error);
    return null;
  }
};

// Sign out from Google
export const signOutFromGoogle = async () => {
  try {
    await gapi.auth2.getAuthInstance().signOut();
    console.log("User signed out successfully");
  } catch (error) {
    console.error("Error during sign-out:", error);
  }
};
export const listFiles = async () => {
  try {
    const response = await gapi.client.drive.files.list({
      pageSize: 10,
      fields: "nextPageToken, files(id, name)",
    });
    console.log("Files retrieved successfully:", response);
    return response;
  } catch (error) {
    console.error("Error listing files:", error);
    throw error; // To ensure the error is caught and handled appropriately in the calling function
  }
};
